import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddressSection from "./AddressSection";
import CheckoutInformation from "./CheckoutInformation";
import DeliveryInfo from "./DeliveryInfo";
import AddressInfo from "./AddressInfo";
import SpecialComment from "./SpecialComment";
import "./checkout-info.scss";
import { useGetCustomerAddressList } from 'hooks/useGetCustomerAddressList';
import { useConfig } from 'hooks/useConfig';
import { AddressTypes, DEBUG } from 'config/constant';
import { selectBillingAddress } from 'redux/actions';

const storeTypeSlots = {
  store_pickup: "pickup_slots",
  delivery: "delivery_slots",
};

const CheckoutInfo = () => {
  const [showAddress, setShowAddress] = useState(false);
  const [showBillingAddress, setShowBillingAddress] = useState(false);

  const { allowBillingAddress } = useConfig()

  const {checkoutStoreType} = useSelector(({ checkout }) => checkout);
  const { storeTimeSlots } = useSelector(({ store }) => store);
  const selectDateAndTimeOptions =
      storeTimeSlots &&
      storeTimeSlots[storeTypeSlots[checkoutStoreType]] &&
      storeTimeSlots[storeTypeSlots[checkoutStoreType]]
            .map((slot) => slot.process_slots)
            .flat()
            .map((process_slot) => {
              return {
                title: process_slot?.shipping_date_day_time,
                value: process_slot,
              };
            });

  const { customerAddressList, customerAddressListLoading } = useGetCustomerAddressList();
  const dispatch = useDispatch();

  useEffect(() => {
    const billingAddressAvailable = customerAddressList?.filter(a => a.status === AddressTypes.billing).length > 0
    setShowBillingAddress(billingAddressAvailable)

    if (billingAddressAvailable) {
      if (DEBUG) debugger
    }

    if (!billingAddressAvailable) {
      // clearing old selection in case user add address... select and then delete the selected addresss
      dispatch(selectBillingAddress(""));
    }

    if (checkoutStoreType === 'delivery' && customerAddressList?.length && !customerAddressListLoading) {
      setShowAddress(true);
    }
    if (checkoutStoreType === 'store_pickup') {
      setShowAddress(true);
    }
  }, [checkoutStoreType, customerAddressList, customerAddressListLoading]);

  const handleSelectPaymentMethod = (method) => {
    if (method === "store_pickup") {
      setShowAddress(true);
    }
  }

  return (
    <div className="checkout-info-section">
      <div className="container">
        <div className="grid">
          <div className="grid-items">
            <DeliveryInfo
              selectDateAndTimeOptions={selectDateAndTimeOptions}
              handleSelectPaymentMethod={handleSelectPaymentMethod}
            />

            <Addresss
              showAddress={showAddress}
              handleAddNewAddress={() => setShowAddress(false)}
              isAddressList={() => setShowAddress(true)}
              isBillingAddress={false}
            />

            {allowBillingAddress ? (
              <Addresss
                showAddress={showBillingAddress}
                handleAddNewAddress={() => setShowBillingAddress(false)}
                isAddressList={() => setShowBillingAddress(true)}
                isBillingAddress={true}
              />
            ) : null}

            <SpecialComment />
          </div>

          <div className="grid-items">
            <CheckoutInformation />
          </div>
        </div>
      </div>
    </div>
  )
};

function Addresss({
  showAddress,
  handleAddNewAddress,
  isAddressList,
  isBillingAddress,
}) {
  if (showAddress) {
    return (
      <AddressInfo
        handleAddNewAddress={handleAddNewAddress}
        isBillingAddress={isBillingAddress}
      />
    )
  }

  return (
    <AddressSection
      isAddressList={isAddressList}
      isBillingAddress={isBillingAddress}
    />
  )
}

export default CheckoutInfo;
